partner
<template>
  <Content title="合作的国内外航空公司">
    <div class="d-flex flex-wrap justify-content-between align-items-center">
      <img
        class="partner-logo"
        v-for="index in 24"
        :key="index"
        :src="`/images/pages/gp/partner-logo-${index >= 10 ? index : '0' + index}.png`"
      />
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'MobilePartner',
  components: { Content },
}
</script>

<style lang="scss" scoped>
.partner-logo {
  width: 33%;
  box-shadow: 0px 2px 10px 0px rgba(240, 242, 244, 1);
  border-radius: 2px;
  object-fit: cover;
}
</style>
